import React from 'react';
import { SelectionAll } from 'phosphor-react';
import { Typography } from '../Typography';
import { Button } from '../Button';
import { MultiSelectionMenuContainer } from './MultiSelectionMenu.styles';
import { MultiSelectionMenuProps } from './types';
import { mosaiqTheme } from '../../theme';

const MultiSelectionMenu = ({
  selectedIds,
  options = [],
  onCancelSelection,
  onSelectAll,
  offset = 80,
}: MultiSelectionMenuProps) => {
  return (
    <MultiSelectionMenuContainer elevation={2} minWidth={40} offset={offset} padding={[1, 2]}>
      <Typography variant="body3" color="white" fontWeight={500}>
        {selectedIds.length} {selectedIds.length > 1 ? 'items' : 'item'} selected
      </Typography>
      <Button
        variant="primary"
        startAdornment={<SelectionAll size={16} color={mosaiqTheme.colors.passive} />}
        onClick={onSelectAll}
      >
        Select All
      </Button>
      {options.map((option) => (
        <Button
          key={option.text}
          variant="primary"
          startAdornment={option.icon}
          onClick={() => option.action?.(selectedIds)}
        >
          {option.text}
        </Button>
      ))}

      <Button variant="primary" onClick={onCancelSelection}>
        Cancel
      </Button>
    </MultiSelectionMenuContainer>
  );
};

export default MultiSelectionMenu;
